// @flow
import React, { Component } from 'react';
import {
  ModelRowTr,
  ModelListTd,
  SpacerTd,
  EditIcon,
  DeleteIcon,
  ModelRowActionsTd
} from '../../../../../components/ModelListStyles';
import { type FailedMerchant } from '../../../../../utilities/types';

import {
  Default,
  Desktop,
  Tablet,
  Mobile
} from '../../../../../components/Responsive';
import { ActionRowButtons } from './FailedMerchantStyles';

type Props = {
  merchant: FailedMerchant,
  expandRow: (id: number) => void,
  expanded: boolean,
  deleteFailedMerchant: (failedMerchantId: number, showModal?: boolean) => void,
  handleEditClick: (merchant: FailedMerchant) => void
};

export default class FailedMerchantsTableRow extends Component<Props> {
  handleClick = () => {
    this.props.expandRow(this.props.merchant.id);
  };
  handleDeleteClick = () => {
    this.props.deleteFailedMerchant(this.props.merchant.id, true);
  };
  handleEditClick = () => {
    this.props.handleEditClick(this.props.merchant);
  };
  render() {
    return (
      <ModelRowTr
        onClick={this.handleClick}
        expandedDevice={this.props.expanded}
        hoverStylesLg
      >
        <SpacerTd />
        <ModelListTd>{this.props.merchant.company_name}</ModelListTd>
        <ModelListTd rightMobile firstCapital color="red">
          {this.props.merchant.error_message}
        </ModelListTd>
        <Mobile>
          <SpacerTd />
        </Mobile>
        <Desktop>
          <ModelListTd right>{this.props.merchant.email}</ModelListTd>
        </Desktop>

        <Default>
          <ModelRowActionsTd right>
            <ActionRowButtons onClick={this.handleEditClick}>
              <EditIcon name="edit" /> Edit
            </ActionRowButtons>
            <ActionRowButtons onClick={this.handleDeleteClick}>
              <DeleteIcon name="delete" colorName="brand" />
              <Desktop>Delete</Desktop>
            </ActionRowButtons>
          </ModelRowActionsTd>
        </Default>
        <Tablet>
          <SpacerTd />
        </Tablet>
      </ModelRowTr>
    );
  }
}
